/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Redirect, Route, useLocation,
} from 'react-router';
import { UserContext } from '../contexts/User';
import { canAccessRoute } from '../utils/permissions';

export function PrivateRoute({
  component, accountLevel = 1, permission, ...rest
}) {
  const location = useLocation();
  const {
    user, accessToken, member, twoFactorToken,
  } = useContext(UserContext);

  if (twoFactorToken === 'temp_2fa_required') return <Redirect to="/twoFactor" />;

  // // Check workspace authentication logic
  // if (workspace && workspace.authentication) {
  //   if (workspace.authentication === 'Google Authenticator') {
  //     // Check 2FA expiry
  //     if (member && member.lastTwoFactorAuth) {
  //       const maxAgeMinutes = parseInt(workspace.twoFactorExpiry, 10) || 1440;
  //       const lastAuth = new Date(member.lastTwoFactorAuth);
  //       const now = new Date();
  //       const diffMinutes = (now - lastAuth) / (1000 * 60);
  //       if (diffMinutes > maxAgeMinutes) {
  //         return <Redirect to="/twoFactor" />;
  //       }
  //     } else {
  //       // No lastTwoFactorAuth, require 2FA
  //       return <Redirect to="/twoFactor" />;
  //     }
  //   }
  //   // If authentication is not 'Email', allow access
  // }
  // If workspace.authentication is not set, allow access

  if (user && accessToken) {
    // Check if user can access this route
    if (member && canAccessRoute(permission, accountLevel, member)) {
      return <Route {...rest} component={component} />;
    }
    return <Redirect to="/workspaces" />;
  }
  // Don't redirect if a new user navigates directly to the signup page (likely from email invite)
  if (location.pathname === '/signup') return <Route {...rest} component={component} />;
  return <Redirect to="/" />;
}

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  accountLevel: PropTypes.number,
  permission: PropTypes.string,
  workspace: PropTypes.shape({
    authentication: PropTypes.string,
  }),
};
